import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-file-icon',
  template: `
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_19048_19593)">
        <path
          d="M6.22439 12.4446H12.4466V14.0001H6.22439V12.4446ZM6.22439 9.33344H12.4466V10.889H6.22439V9.33344ZM10.8911 1.55566L4.66884 1.55566C3.81328 1.55566 3.11328 2.25566 3.11328 3.11122L3.11328 15.5557C3.11328 16.4112 3.8055 17.1112 4.66106 17.1112H14.0022C14.8577 17.1112 15.5577 16.4112 15.5577 15.5557V6.22233L10.8911 1.55566ZM14.0022 15.5557H4.66884L4.66884 3.11122L10.1133 3.11122V7.00011L14.0022 7.00011V15.5557Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_19048_19593">
          <rect width="18.6667" height="18.6667" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileIconComponent {}
